import React from 'react';
import { Chip, Menu, MenuItem } from '@mui/material';
import { useRole } from '../contexts/RoleContext'; // ✅ corrigido para "contexts"

export default function RoleSelector(){
  const { roles, currentRole, setRole } = useRole();
  const [anchor, setAnchor] = React.useState(null);
  const label = currentRole === 'auto' ? 'Automático (todos)' : currentRole;

  return (
    <>
      <Chip
        label={`Perfil: ${label}`}
        onClick={(e)=>setAnchor(e.currentTarget)}
        sx={{ ml: 1 }}
        variant="outlined"
      />
      <Menu open={!!anchor} anchorEl={anchor} onClose={()=>setAnchor(null)}>
        <MenuItem onClick={()=>{ setRole('auto'); setAnchor(null); }}>Automático (todos)</MenuItem>
        {roles.map(r => (
          <MenuItem key={r} onClick={()=>{ setRole(r); setAnchor(null); }}>
            {r}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
